module.exports = __webpack_public_path__ + "static/initials-home-d180108ed4b9d3dbdce41d34150f34c4.png";